package com.essntl.features.proposal.ui.selectservice.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.tag.domain.model.TagModel
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun TagServiceItem(
    tag: TagModel,
) {
    Box(
        modifier = Modifier
            .clip(RoundedCornerShape(1.spacing))
            .background(MaterialTheme.esColorScheme.bgPrimary)
            .padding(
                vertical = 0.5f.spacing,
                horizontal = 0.5f.spacing
            )
    ) {
        Text(
            text = tag.name,
            color = MaterialTheme.esColorScheme.textSecondary,
            style = MaterialTheme.esTypography.c1Medium13,
        )
    }
}